import mainStyle from "../../mainStyle.module.scss";
import React, { useState, useEffect } from 'react';
import { cloneDeep } from "lodash";
import { useTheme } from "@mui/material/styles";
import { message } from 'antd';
import { Typography } from "@mui/material";
// import OTPInput from './OTPInput';
import { ReactComponent as CopyIcon } from "assets/images/icons/btn_copy.svg";

const MfaPhase4 = (props) => {
  const {
    mfaSetting
  } = props;
  const theme = useTheme();

  const [recoveryCode, setRecoveryCodes] = useState('');

  const handleCopyCode = async () => {
    if(recoveryCode === null || recoveryCode === undefined || recoveryCode === ''){
      return;
    }
    try {
      await navigator.clipboard.writeText(recoveryCode);
      message.success('已複製到剪貼簿！');
    } catch (err) {
      message.error('複製失敗');
      // console.error('Copy failed', err);
    }
  }

  useEffect(() => {
    if(mfaSetting){
      setRecoveryCodes(mfaSetting.recoveryCodes[0])
    }
  }, [mfaSetting]);

  return (
    <>
      <div className={mainStyle['modal_rows']} >
        <div className={mainStyle['modal_Block']} style={{gap:'5px'}}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Please
          </Typography>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontWeight: theme.typography.customFontWeight[3],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Save
          </Typography>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            this recovery code.
          </Typography>
        </div>
        <div className={mainStyle['modal_Block']} style={{gap:'5px'}}>
          <Typography
            sx={{
              color: theme.palette.primary.greyPrimary,
              fontSize: theme.typography.customFontSize[4],
              fontFamily: theme.typography.fontFamily,
            }}
            >
            Once your device cannot provide an authentication code, you can reset MFA Authentication by this recovery code.
          </Typography>
        </div>
        <div className={mainStyle['modal_Block']} style={{margin: '10px 0'}}>
          <div style={{ margin: '10px 0', border:'1px solid #aaa', borderRadius:'10px', 
            display:'flex', justifyContent:'center', alignItems:'center', 
            gap:'20px', height:'100px', width:'100%'}}>
              <Typography
                sx={{
                  color: theme.palette.primary.greyPrimary,
                  fontSize: theme.typography.customFontSize[4],
                  fontWeight: theme.typography.customFontWeight[3],
                  fontFamily: theme.typography.fontFamily,
                }}
                >
                {recoveryCode}
              </Typography>
              <CopyIcon width={45} style={{cursor:'pointer'}} onClick={()=>{handleCopyCode()}} />
          </div>
        </div>
      </div>
    </>
  );
}

export default MfaPhase4;